import { useQuery } from "@tanstack/react-query";
import {
  communicationLogService,
  CommunicationLogFilters,
} from "../../services/admin/communicationLog.service";

export function useCommunicationLogs(filters: CommunicationLogFilters) {
  return useQuery({
    queryKey: ["communication-logs", filters],
    queryFn: () => communicationLogService.list(filters),
    placeholderData: (previousData) => previousData,
  });
}

export function useCommunicationLog(id: string | null) {
  return useQuery({
    queryKey: ["communication-logs", "detail", id],
    queryFn: () => communicationLogService.getById(id as string),
    enabled: !!id,
  });
}
